import AuroraHeader from './AuroraHeader';
import { services } from '@broadleaf/admin-components';

const { ComponentRegistrar } = services;


ComponentRegistrar.registerComponent('blHeader', AuroraHeader);